import Carousel from '@admin/components/carousel'
import Avatar from '@admin/components/avatar'
import Button from '@admin/components/button'
import Image from '@admin/components/image'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

class Announcement extends React.Component {

  static contextTypes = {
    host: PropTypes.object,
    portal: PropTypes.object,
    provider: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    announcement: PropTypes.object,
    is_new: PropTypes.bool
  }

  contentRef = React.createRef()

  state = {
    expanded: false,
    overflow: false,
    userExpanded: false
  }

  _handleCTA = this._handleCTA.bind(this)
  _handleExpand = this._handleExpand.bind(this)

  render() {
    const { announcement, is_new } = this.props
    const { expanded, overflow } = this.state
    const author = this._getAuthor()
    return (
      <div className={ this._getClass() }>
        <div className="maha-announcement-header">
          <div className="maha-announcement-header-logo">
            <Avatar { ...this._getAvatar(author) } />
          </div>
          <div className="maha-announcement-header-details">
            <div className="maha-announcement-header-name">
              { author.name }
            </div>
            <div className="maha-announcement-header-timestamp">
              { this._getTimestamp() }
            </div>
          </div>
          { is_new &&
            <div className="maha-announcement-header-new">
              New
            </div>
          }
        </div>
        { announcement.images?.length > 0 &&
          <div className="maha-announcement-carousel">
            <Carousel { ...this._getCarousel() } />
          </div>
        }
        <div className="maha-announcement-body">
          <div 
            className="maha-announcement-body-content" 
            ref={this.contentRef}
            dangerouslySetInnerHTML={ { __html: announcement.body } } 
          />
        </div>
        { (!expanded && overflow) &&
          <div className="maha-announcement-more">
            <Button { ...this._getMore() } />
          </div>      
        }
        { (expanded && announcement.cta?.show === true) &&
          <div className="maha-announcement-button">
            <Button { ...this._getCTA() }/>
          </div>
        }
      </div>
    )
  }

  componentDidMount() {
    this._handleCheck()
    window.addEventListener('resize', this._handleCheck)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._handleCheck)
  }

  _getAuthor() {
    const { announcement } = this.props
    const { provider } = this.context
    return announcement?.author?.user ? {
      name: announcement.author.user.full_name,
      photo: announcement.author.user.photo
    } : {
      name: provider.title,
      photo: provider.logo
    }
  }

  _getAvatar(author) {
    return {
      user: {
        photo: author.photo
      }
    }
  }

  _getCarousel() {
    const { announcement } = this.props
    return {
      slides: announcement.images.map((image, index) => (
        <div className="maha-announcement-carousel-slide" key={`slide_${index}`}>
          <Image { ...this._getImage(image) } />
        </div>
      ))
    }
  }

  _getClass() {
    const { expanded, overflow } = this.state
    const classes = ['maha-announcement']
    if(!expanded && overflow) classes.push('collapsed')
    return classes.join(' ')
  }

  _getCTA() {
    const { cta } = this.props.announcement
    return {
      label: cta.text,
      color: 'blue',
      fluid: true,
      handler: this._handleCTA
    }
  }

  _getImage(image) {
    return {
      src: image.asset.path,
      transforms: image.transforms
    }
  }

  _getMore() {
    return {
      label: 't(Read more)',
      className: 'link',
      handler: this._handleExpand
    }
  }

  _getTimestamp() {
    const { announcement } = this.props
    const published_at = announcement.published_at ? moment(announcement.published_at) : moment()
    return published_at.format('MMM D')
  }

  _handleCheck = () => {
    if(!this.contentRef.current) return
    const contentHeight = this.contentRef.current.scrollHeight
    const lineHeight = parseFloat(getComputedStyle(this.contentRef.current).lineHeight) || 20
    const numberOfLines = contentHeight / lineHeight
    const overflow = numberOfLines > 5
    
    // Only auto-set expanded state if user hasn't manually expanded it
    this.setState(prevState => ({ 
      overflow,
      expanded: prevState.userExpanded ? prevState.expanded : !overflow
    }))
  }

  _handleCTA() {
    const { cta } = this.props.announcement
    const { admin_host } = this.context.provider
    if(cta?.url.startsWith(admin_host)) {
      this.context.router.push(cta.url.replace(admin_host, ''))
    } else if(cta?.url) {
      this.context.host.window.open(cta.url)
    }
    this.context.portal.setDrawer(null)
  }

  _handleExpand() {
    this.setState({ 
      expanded: true,
      userExpanded: true
    })
  }
}

export default Announcement